export default __webpack_public_path__ + "static/media/Screenshot_2.725ab41e.png";